import { QuestionBase } from './question-base';

export class UibButtonQuestion extends QuestionBase<string> {
  controlType = 'uib-button';
  type = 'number';

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
